import {
  ChangeDetectionStrategy,
  Component,
  inject
} from "@angular/core";
import { Dialog } from 'primeng/dialog';
import { LoadScreenService } from "../../load-screen.service";

@Component({
  selector: "velocity-loader-dialog",
  templateUrl: "./loader-dialog.component.html",
  styleUrls: ["./loader-dialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Dialog,
  ],
})
export class LoaderDialogComponent {
  private loadScreenService = inject(LoadScreenService);

  message = this.loadScreenService.message;

  loading = this.loadScreenService.isOpen;

  image = this.loadScreenService.image;
}
